enum BoardItemStatus {
  OPEN,
  CLOSE,
}

export { BoardItemStatus };
